import { FormattedInput } from "@swa-ui/core";

import { withFormField } from "../withFormField";

/**
 * FormattedInputFormField provides support for a standard FormattedInput component to be used in a Form.
 */

export const FormattedInputFormField = withFormField(FormattedInput);
